import Box from '../Common/Box';
import {Zoom} from '@mui/material';
import Paper from '@mui/material/Paper';
import React, {useState} from 'react';
import ControlButton from '../Common/ControlButton';
import SettingsApplications from '@mui/icons-material/SettingsApplications';
import {useManager} from '../Common/hooks';

interface ManagerToggleProps {
    bottom?: number | string;
    right?: number | string;
    left?: number | string;
    top?: number | string;
}

export default function ManagerToggle(
        {
            bottom,
            right,
            left,
            top,
        }: ManagerToggleProps) {

    const [overlayVisible, setOverlayVisible] = useState(false);
    const {managerEnabled, toggleAppManager} = useManager();

    return <Box
            zIndex={10000000}
            row
            padding={"10px"}
            position={"absolute"}
            bottom={bottom}
            right={right}
            left={left}
            top={top}
            style={{
                pointerEvents: "none"
            }}
            onMouseLeave={() => {
                setOverlayVisible(false)
            }}
    >
        <Box
                style={{
                    position: "relative",
                }}
        >
            <Box
                    style={{
                        pointerEvents: "all",
                        width: "50%",
                        position: "absolute",
                        height: "100%",
                    }}
                    onMouseOver={() => {
                        setOverlayVisible(true)
                    }}
            />
            <Zoom in={overlayVisible}>
                <Paper elevation={4} style={{
                    display: "flex",
                    padding: "10px",
                    position: "relative",
                    pointerEvents: overlayVisible ? "all" : "none"
                }}>
                    <ControlButton
                            width={35}
                            enabled={managerEnabled}
                            icon={SettingsApplications}
                            onClick={() => {
                                toggleAppManager();
                            }}
                    />
                </Paper>
            </Zoom>
        </Box>
    </Box>
};
